<template>
    <div class="container remove-padding-margin bg-gray" id="homeoutletworkshop">
        <div class="header-top bg-white">
            <div class="row justify-content-center align-items-center set-row pageSearchOutlet pageSearchWorkshop">
                <div class="col-md-9 col-sm-9 col-9 remove-padding">
                    <input class="inputSearch" id="input_search_outlet" type="text" v-on:keyup="inputsearch"
                           v-model="searchKey"
                           autofocus
                           placeholder="Cari..">
                </div>
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                    <img class="imageSearch" @click="closeSearch" src="../../assets/img/x2.svg" alt="">
                </div>
            </div>
            <nav class="nav-center pageDefault">
                <div class="row justify-content-center align-items-center set-row">
                    <div class="col-md-3 col-sm-3 col-3 remove-padding" @click="dashboard">
                        <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div class="col-md-6 col-sm-6 col-6 text-center remove-padding">
                        <p style="margin:0;">Outlet & Workshop</p>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3 remove-padding">
                        <img class="imageSearch" src="../../assets/icons/search.svg" @click="showSearch" alt="">
                    </div>
                </div>
            </nav>
            <div class="nav nav-tabs custom bg-white pageDefault" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-home-tab" :data-toggle="validateAccess('outletWorkshop.outlet') ? 'tab' : ''" href="#nav-Outlet"
                   v-on:click="validateAccess('outletWorkshop.outlet') && changeStatusTabsoutlet()" role="tab"
                   aria-controls="nav-home" aria-selected="true">Outlet</a>
                <a class="nav-item nav-link" id="nav-profile-tab" :data-toggle="validateAccess('outletWorkshop.workshop') ? 'tab' : ''" href="#nav-Workshop"
                   v-on:click="changeStatusTabsworkshop" role="tab"
                   aria-controls="nav-profile" aria-selected="false">Workshop</a>
            </div>
        </div>
        <div class="backgroundSearch pageSearchOutlet">
            <div class="d-block" id="list-search-outlet-scrolled" style="overflow-y: scroll; height: 100vh">
                <div class="d-block" id="list-search-outlet">
                    <div id="loading-bar-spinner" class="spinner">
                        <div class="spinner-icon"></div>
                    </div>
                    <div class="flex-1">
                        <div class="cardSearch">
                            <h6 class="font-14 remove-margin textTotalSearch" id="textSearch"></h6>
                            <br>
	                        <div class="set-card-wo-xp-20 pb-0" v-for="dataOutlet in outletSearch" :key="dataOutlet.outlet.idoutlet"
	                             @click="detail(dataOutlet.outlet.idoutlet)">
		                        <div class="row add-padding-default m-0" v-if="dataOutlet.outlet.logo_url===''">
			                        <div class="col-md-3 col-sm-3 col-3  remove-padding">
				                        <img class="" src="../../assets/gambar/Rectangle43.svg" alt=""
				                             style="width: 48px;border: 1px solid #E1E5EC;box-sizing: border-box;border-radius: 3px;">
			                        </div>
			                        <div class="col-md-8 col-sm-8 col-8  remove-padding">
				                        <div class="font-16 remove-margin font-weight-bold capitalize"
                                     v-html="searchHighlight(dataOutlet.outlet.nama, searchKey)">
				                        </div>
				                        <div class="font-13 remove-margin nomore capitalize addressstyle"
                                     v-html="searchHighlight(dataOutlet.outlet.alamat, searchKey)">
				                        </div>
				                        <div class="font-13 remove-margin nomore capitalize addressstyle"
				                             style="margin-bottom: 10px;"
                                     v-html="searchHighlight(dataOutlet.outlet.kota, searchKey)"
                                >
				                        </div>
			                        </div>
			                        <div class="col-md-1 col-sm-1 col-1  remove-padding">
				                        <img src="../../assets/icons/chevron_right_4.svg" alt="">
			                        </div>
		                        </div>
		                        <div class="row add-padding-default m-0" v-else>
			                        <div class="col-md-3 col-sm-3 col-3  remove-margin remove-padding">
				                        <figure class="box">
					                        <img class="imgFit" v-if="dataOutlet.outlet.logo_url.includes('bos_revamp/')"
					                             v-bind:src="imgBucketSrc + dataOutlet.outlet.logo_url"
					                             alt="">
					                        <img class="imgFit" v-else
					                             v-bind:src="'https://res.cloudinary.com/sinadme/c_scale,h_200/'+ dataOutlet.outlet.logo_url"
					                             alt="">
				                        </figure>
			                        </div>
			                        <div class="col-md-8 col-sm-8 col-8  remove-padding">
				                        <div class="font-16 remove-margin font-weight-bold capitalize "
                                     v-html="searchHighlight(dataOutlet.outlet.nama, searchKey)">
				                        </div>
				                        <div class="font-13 remove-margin nomore capitalize addressstyle"
                                     v-html="searchHighlight(dataOutlet.outlet.alamat, searchKey)">
				                        </div>
				                        <div class="font-13 remove-margin nomore capitalize addressstyle"
				                             style="margin-bottom: 10px;"
                                     v-html="searchHighlight(dataOutlet.outlet.kota, searchKey)">
				                        </div>
			                        </div>
			                        <div class="col-md-1 col-sm-1 col-1  remove-padding">
				                        <img src="../../assets/icons/chevron_right_4.svg" alt="">
			                        </div>
		                        </div>
		                        <div class="card-footer bg-transparent" v-if="dataOutlet.outlet.workshop || dataOutlet.outlet.sec_active!==2">
			                        <div class="row m-0">
				                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 pl-0 pr-0">
					                        <div class="f-12 f-c-midgrey nomore" v-if="dataOutlet.outlet.workshop">
						                        <img src="../../assets/img/link-grey.svg" class="m-r-8" alt="">
						                        <b>Workshop {{ dataOutlet.outlet.workshop.nama }}</b>
					                        </div>
				                        </div>
				                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 pl-0 pr-0 text-right">
					                        <div class="f-c-red f-12 badge color-red" v-if="dataOutlet.outlet.sec_active === 1 && !dataOutlet.data_active.expired"><b>Sisa trial {{ dataOutlet.outlet.data_active.remaining_trail_days }} hari</b></div>
					                        <div class="f-c-red f-12 badge color-red" v-if="dataOutlet.outlet.sec_active === 0 || dataOutlet.data_active.expired"><b>Belum Aktivasi</b></div>
				                        </div>
			                        </div>
		                        </div>
	                        </div>
	                        
                            <div class="loadmoreSpinner" id="loadingSpinnerOutletSearch" style="display: none">
                                <center>
                                    <div class="sp sp-circle"></div>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="backgroundSearch pageSearchWorkshop">

            <div class="d-block" id="list-search-workshop-scrolled" style="overflow-y: scroll; height: 100vh">
                <div class="d-block" id="list-search-workshop">
                    <div id="loading-bar-spinner2" class="spinner">
                        <div class="spinner-icon"></div>
                    </div>
                    <div class="flex-1">
                        <div class="cardSearch">
                            <h6 class="font-14 remove-margin textTotalSearch" id="textSearchWorkshop"></h6>
                            <br>
                          <div class="set-card-wo-xp-20 pb-0" v-for="dataWorkshop in workshopSearch" :key="dataWorkshop.idworkshop"
                               @click="detailworkshop(dataWorkshop.idworkshop)">
                            <div class="row add-padding-default remove-margin">
                              <div class="col-md-10 col-sm-10 col-10  remove-padding">
                                <div class="font-16 remove-margin font-weight-bold capitalize"
                                     v-html="searchHighlight(dataWorkshop.nama, searchKey)">
                                </div>
                                <div class="font-13 f-c-midgrey remove-margin nomore capitalize addressstyle">
                                  {{dataWorkshop.alamat}}
                                </div>
                                <div class="font-13 f-c-midgrey mar-bot-10 nomore capitalize addressstyle"
                                     style="margin-bottom: 10px;">
                                  {{ dataWorkshop.kota}}
                                </div>
                              </div>
                              <div class="col-md-2 col-sm-2 col-2  remove-padding text-right">
                                <img src="../../assets/icons/chevron_right_4.svg" alt="">
                              </div>
                            </div>
                            <div class="card-footer bg-transparent" v-if="dataWorkshop.outlet">
                              <div class="f-12 f-c-midgrey nomore">
                                <img src="../../assets/img/link-grey.svg" class="m-r-8" alt="">
                                {{ dataWorkshop.outlet.nama }}
                              </div>
                            </div>
                          </div>
                            <div class="loadmoreSpinner" id="loadingSpinnerWorkshopSearch" style="display: none">
                                <center>
                                    <div class="sp sp-circle"></div>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <main class="add-padding-default pageDefault">
            <div class="tab-content" id="nav-tabContent">
                <div class="tab-pane fade show active" id="nav-Outlet" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="flex-100" id="outlet">
                        <div class="flex-1" v-if="outlet.length === 0" id="outlet_aktif">
                            <div class="image text-alignC" v-if="outletnontest.length===0">
                                <img class="img-fluid" src="../../assets/icons/Hanger.svg" alt="">
                                <h5 class="text-center">Belum ada outlet yang terdaftar</h5>
                                <h6 class="text-center">Silahkan klik tombol + untuk menambahkan</h6>
                            </div>
                            <div class="image text-alignC" v-else>
                                <img class="img-fluid" src="../../assets/icons/Danger.svg" alt="">
                                <h5 class="text-center">Belum ada outlet yang Nonaktif</h5>
                                <button class="btn btn-outline-small" @click="aktifnonaktifoutlet">Lihat Outlet
                                    Nonaktif
                                </button>
                            </div>
                        </div>

                        <div class="flex-1 pad-top-50" v-else>
                            <div class="carddd">
                                <h6 class="font-14 remove-margin">Total {{outlet_lenght_data}} Outlet</h6>
                                <FilterSorting :jenisFilter="'outlet'" @filter="filter"/>
                                <br>
	                            <div class="set-card-wo-xp-20 pb-0" v-for="o in outlet" :key="o.idoutlet"
	                                 @click="detail(o.idoutlet)">
		                            <div class="row add-padding-default m-0" v-if="o.logo_url===''">
			                            <div class="col-md-3 col-sm-3 col-3  remove-padding">
				                            <img class="" src="../../assets/gambar/Rectangle43.svg" alt=""
				                                 style="width: 48px;border: 1px solid #E1E5EC;box-sizing: border-box;border-radius: 3px;">
			                            </div>
			                            <div class="col-md-8 col-sm-8 col-8  remove-padding">
				                            <div class="font-16 remove-margin font-weight-bold capitalize">
					                            {{ o.nama }}
				                            </div>
				                            <div class="font-13 f-c-midgrey remove-margin nomore capitalize addressstyle">
					                            {{o.alamat}}
				                            </div>
				                            <div class="font-13 f-c-midgrey remove-margin nomore capitalize addressstyle"
				                                 style="margin-bottom: 10px;">
					                            {{ o.kota}}
				                            </div>
			                            </div>
			                            <div class="col-md-1 col-sm-1 col-1  remove-padding text-right">
				                            <img src="../../assets/icons/chevron_right_4.svg" alt="">
			                            </div>
		                            </div>
		                            <div class="row add-padding-default m-0" v-else>
			                            <div class="col-md-3 col-sm-3 col-3  remove-margin remove-padding"
			                                 v-if="o.logo_url.includes('bos_revamp/')">
				                            <img class="imgFit"
				                                 v-bind:src="imgBucketSrc + o.logo_url"
				                                 alt="">
			                            </div>
			                            <div class="col-md-3 col-sm-3 col-3  remove-margin remove-padding"
			                                 v-else>
				                            <img class="imgFit"
				                                 v-bind:src="'https://res.cloudinary.com/sinadme/c_scale,h_200/'+ o.logo_url"
				                                 alt="">
			                            </div>
			                            <div class="col-md-8 col-sm-8 col-8  remove-padding">
				                            <div class="font-16 remove-margin font-weight-bold capitalize">
					                            {{ o.nama }}
				                            </div>
				                            <div class="font-13 f-c-midgrey remove-margin nomore capitalize addressstyle">
					                            {{o.alamat}}
				                            </div>
				                            <div class="font-13 f-c-midgrey remove-margin nomore capitalize addressstyle"
				                                 style="margin-bottom: 10px;">
					                            {{ o.kota}}
				                            </div>
			                            </div>
			                            <div class="col-md-1 col-sm-1 col-1  remove-padding text-right">
				                            <img src="../../assets/icons/chevron_right_4.svg" alt="">
			                            </div>
		                            </div>
		                            <div class="card-footer bg-transparent" v-if="o.workshop || o.active!==2">
			                            <div class="row m-0">
				                            <div class="col-lg-6 col-md-6 col-sm-6 col-6 pl-0 pr-0">
					                            <div class="f-12 f-semi f-c-midgrey nomore capitalize" v-if="o.workshop">
						                            <img src="../../assets/img/link-grey.svg" class="m-r-8" alt="">
						                            <b>Workshop {{ o.workshop.nama }}</b>
					                            </div>
				                            </div>
				                            <div class="col-lg-6 col-md-6 col-sm-6 col-6 pl-0 pr-0 text-right">
					                            <div class="f-c-red f-12 badge color-red" v-if="o.active === 1 && !o.expired"><b>Sisa trial {{ o.sisa_trial }} hari</b></div>
					                            <div class="f-c-red f-12 badge color-red" v-if="o.active === 0 || o.expired"><b>Belum Aktivasi</b>
					                            </div>
				                            </div>
			                            </div>
		                            </div>
	                            </div>
	                            
                                <div class="loadmoreSpinner" id="loadingSpinnerOutlet" style="display: none">
                                    <center>
                                        <div class="sp sp-circle"></div>
                                    </center>
                                </div>
                            </div>
                        </div>

                        <!-- PLUS ICON -->
                        <div class="flying-button-wrapper" v-if="validateAccess('outlet.create')">
                            <div class="flying-inside">
                                <div class="flying-button btn-add-outlet" @click="add"></div>
                            </div>
                        </div>

                    </div>
                    <div class="flex-100" id="outletnonaktif">
                        <div class="flex-1" v-if="outletnonaktif.length === 0">
                            <div>
                                <div class="image text-alignC">
                                    <img class="img-fluid" src="../../assets/icons/Danger.svg" alt="">
                                    <h5 class="text-center">Belum ada outlet yang Nonaktif</h5>
                                    <button class="btn btn-outline-small" @click="aktifnonaktifoutlet">Lihat Outlet
                                        Aktif
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1 pad-top-50" v-else>
                            <div class="carddd">
                                <h6 class="font-14 remove-margin">Total {{outlet_nonaktif_lenght_data}} Outlet
                                    Nonaktif</h6>
                                <FilterSorting :jenisFilter="'outletNonaktif'" @filter="filter"/>
                                <br>
	                            <div class="set-card-wo-xp-20 pb-0" v-for="on in outletnonaktif" :key="on.idoutlet"
	                                 @click="detailnonaktif(on.idoutlet)">
		                            <div class="row add-padding-default m-0" v-if="on.logo_url===''">
			                            <div class="col-md-3 col-sm-3 col-3  remove-padding">
				                            <img class="" src="../../assets/gambar/Rectangle43.svg" alt=""
				                                 style="width: 48px;border: 1px solid #E1E5EC;box-sizing: border-box;border-radius: 3px;">
			                            </div>
			                            <div class="col-md-8 col-sm-8 col-8  remove-padding">
				                            <div class="font-16 remove-margin font-weight-bold color-6f7 capitalize">
					                            {{ on.nama }}
				                            </div>
				                            <div class="font-13 f-c-midgrey remove-margin nomore color-6f7 capitalize addressstyle">
					                            {{on.alamat}}
				                            </div>
				                            <div class="font-13 f-c-midgrey remove-margin nomore color-6f7 capitalize addressstyle"
				                                 style="margin-bottom:15px;">
					                            {{ on.kota}}
				                            </div>
			                            </div>
			                            <div class="col-md-1 col-sm-1 col-1  remove-padding text-right">
				                            <img src="../../assets/icons/chevron_right_4.svg" alt="">
			                            </div>
		                            </div>
		                            <div class="row add-padding-default m-0" v-else>
			                            <div class="col-md-3 col-sm-3 col-3  remove-margin remove-padding">
				                            <img class="imgFit color-6f7"
				                                 v-bind:src="imgBucketSrc+ on.logo_url"
				                                 alt="">
			                            </div>
			                            <div class="col-md-8 col-sm-8 col-8  remove-padding">
				                            <div class="font-16 remove-margin font-weight-bold color-6f7 capitalize">
					                            {{ on.nama }}
				                            </div>
				                            <div class="font-13 f-c-midgrey remove-margin nomore color-6f7 capitalize addressstyle">
					                            {{on.alamat}}
				                            </div>
				                            <div class="font-13 f-c-midgrey remove-margin nomore color-6f7 capitalize addressstyle"
				                                 style="margin-bottom: 10px;">
					                            {{ on.kota}}
				                            </div>
			                            </div>
			                            <div class="col-md-1 col-sm-1 col-1  remove-padding text-right">
				                            <img src="../../assets/icons/chevron_right_4.svg" alt="">
			                            </div>
		                            </div>
		                            <div class="card-footer bg-transparent" v-if="on.workshop || on.active!==2">
			                            <div class="row m-0">
				                            <div class="col-lg-6 col-md-6 col-sm-6 col-6 pl-0 pr-0">
					                            <div class="f-12 f-semi f-c-midgrey nomore capitalize" v-if="on.workshop">
						                            <img src="../../assets/img/link-grey.svg" class="m-r-8" alt="">
						                            <b>{{ on.workshop.nama }}</b>
					                            </div>
				                            </div>
				                            <div class="col-lg-6 col-md-6 col-sm-6 col-6 pl-0 pr-0 text-right">
					                            <div class="f-c-red f-12 badge color-red" v-if="on.active === 1 && !on.expired"><b>Sisa trial {{ on.sisa_trial }} hari</b></div>
					                            <div class="f-c-red f-12 badge color-red" v-if="on.active === 0 || on.expired"><b>Belum Aktivasi</b>
					                            </div>
				                            </div>
			                            </div>
		                            </div>
	                            </div>
	                            
                                <div class="loadmoreSpinner" id="loadingSpinnerOutletNonaktif" style="display: none">
                                    <center>
                                        <div class="sp sp-circle"></div>
                                    </center>
                                </div>
                            </div>
                        </div>

                        <!-- PLUS ICON -->
                        <div class="flying-button-wrapper" v-if="validateAccess('outlet.create')">
                            <div class="flying-inside">
                                <div class="flying-button btn-add-outlet" @click="add"></div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="tab-pane fade" id="nav-Workshop" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="flex-100" id="workshop">
                        <div class="flex-1" v-if="leght_data_workshop===0">
                            <div class="empty-state">
                                <div class="empty-state--icon"></div>
                                <div class="f-16 f-bold">Belum ada workshop yang terdaftar</div>
                                <div class="f-14 f-c-midgrey">Klik tombol + untuk menambahkan</div>
                            </div>
                        </div>
                        <div class="flex-1 pad-top-50" v-else>
                            <div class="carddd">
                                <h6 class="font-14 remove-margin">Total {{leght_data_workshop}} Workshop</h6>
                                <FilterSorting :jenisFilter="'workshop'" @filter="filter"/>
                                <br>
                                <div class="set-card-wo-xp-20 pb-0" v-for="w in workshop" :key="w.idworkshop"
                                     @click="detailworkshop(w.idworkshop)">
                                    <div class="row add-padding-default remove-margin">
                                        <div class="col-md-10 col-sm-10 col-10  remove-padding nomore">
                                            <div class="font-16 remove-margin font-weight-bold capitalize">
                                                {{ w.nama }}
                                            </div>
                                            <div class="font-13 f-c-midgrey remove-margin nomore capitalize addressstyle">
                                                {{w.alamat}}
                                            </div>
                                            <div class="font-13 f-c-midgrey mar-bot-10 nomore capitalize addressstyle"
                                                 style="margin-bottom: 10px;">
                                                {{ w.kota}}
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-sm-2 col-2  remove-padding text-right">
                                            <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="card-footer bg-transparent" v-if="w.loginoutletworkshop === 'true'">
                                        <div class="f-12 f-c-midgrey nomore">
                                            <img src="../../assets/img/link-grey.svg" class="m-r-8" alt="">
                                            {{ w.outlet.nama }}
                                        </div>
                                    </div>
                                </div>
                                <div class="loadmoreSpinner" id="loadingSpinnerWorkshop" style="display: none">
                                    <center>
                                        <div class="sp sp-circle"></div>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- PLUS ICON -->
                    <div class="flying-button-wrapper" v-if="validateAccess('workshop.create')">
                        <div class="flying-inside">
                            <div class="flying-button btn-add-ws" @click="addWorkshop"></div>
                        </div>
                    </div>

                </div>

                <div class="flex-100" id="workshopnonaktif" style="display: none">
                    <div class="flex-1" v-if="workshopnontest.length === 0">
                        <div>
                            <div class="image text-alignC">
                                <img class="img-fluid" src="../../assets/icons/Danger.svg" alt="">
                                <h5 class="text-center">Belum ada Workshop yang Nonaktif</h5>
                                <button class="btn btn-outline-small" @click="aktifnonaktifworkshop">Lihat Workshop
                                    Aktif
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 pad-top-50" v-else>
                        <div class="carddd">
                            <h6 class="font-14 remove-margin">Total {{workshop_nonaktif_lenght_data}} Workshop
                                Nonaktif</h6>
                            <FilterSorting :jenisFilter="'workshopNonaktif'" @filter="filter"/>
                            <br>
                            <div class="set-card-wo-xp-20 pb-0" v-for="wn in workshopnontest" :key="wn.idworkshop"
                                 @click="detailworkshopnonaktif(wn.idworkshop)">
                                <div class="row add-padding-default">
                                    <div class="col-md-10 col-sm-10 col-10  remove-padding add-padding-default">
                                        <div class="font-16 remove-margin font-weight-bold capitalize f-c-midgrey">
                                            {{ wn.nama }}
                                        </div>
                                        <div class="font-13 remove-margin nomore capitalize addressstyle f-c-midgrey">
                                            {{wn.alamat}}
                                        </div>
                                        <div class="font-13 mar-bot-10 nomore capitalize addressstyle f-c-midgrey"
                                             style="margin-bottom: 10px;">
                                            {{ wn.kota}}
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-sm-2 col-2  remove-padding text-right">
                                        <img src="../../assets/icons/chevron_right_4.svg" alt="">
                                    </div>
                                </div>
                              <div class="card-footer bg-transparent" v-if="wn.loginoutletworkshop === 'true'">
                                <div class="f-12 f-c-midgrey">
                                  <img src="../../assets/img/link-grey.svg" class="m-r-8" alt="">
                                  {{ wn.outlet.nama }}
                                </div>
                              </div>
                            </div>
                            <div class="loadmoreSpinner" id="loadingSpinnerWorkshopNonaktif" style="display: none">
                                <center>
                                    <div class="sp sp-circle"></div>
                                </center>
                            </div>
                        </div>
                    </div>

                    <!-- PLUS ICON -->
                    <div class="flying-button-wrapper" v-if="validateAccess('outlet.create')">
                        <div class="flying-inside">
                            <div class="flying-button btn-add-outlet" @click="add"></div>
                        </div>
                    </div>

                </div>

            </div>
        </main>
        <div class="modal fade" id="modal-lewati-panduan" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Batal Mengikuti Panduan</h5>
                        <div class="nav-btn kanan tutup">
                        </div>
                    </div>
                    <div class="modal-body">
                        <p>Anda sedang mengikuti panduan pengguna, batal mengikuti panduan akan menghentikan mode
                            panduan. Apakah Anda yakin ingin keluar dari panduan?</p>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-long m-d-20"
                                @click="cekDataOnboarding"
                                data-dismiss="modal">
                            Lanjutkan Panduan
                        </button>
                        <a @click="skipOnboarding(3)" class="m-t-20 f-semi f-12 f-c-blue">Saya Ingin Keluar
                            Dari
                            Mode Panduan</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FilterSorting from "@/component-items/FilterSorting";

    export default {
        name: "HomeOutlet",
        props: ['datalistoutlet', 'statusoutletfilter', 'statusworkshopfilter'],
        components: {
            'FilterSorting': FilterSorting,
        },
        data() {
            return {
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
                outlet: [],
                outletnonaktif: [],
                outletnontest: [],
                workshop: [],
                workshopnontest: [],
                leght_data_workshop: '',
                isClicked: true,
                searchKey: "",
                statusTabs: "outlet",
                outletSearch: [],
                workshopSearch: [],
                // statusoutletfilter:0,

                outletPagination: {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama",
                    orderBy: "ASC",
                },

                workshopPagination: {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama",
                    orderBy: "ASC",
                },

                outletNonaktifPagination: {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama",
                    orderBy: "ASC",
                },

                workshopNonaktifPagination: {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama",
                    orderBy: "ASC",
                },

                outletSearchPagination: {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama",
                    orderBy: "ASC",
                    key: "",
                },

                workshopSearchPagination: {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama",
                    orderBy: "ASC",
                    key: "",
                },
                outlet_lenght_data: 0,
                outlet_nonaktif_lenght_data: 0,
                workshop_nonaktif_lenght_data: 0,

	            bucketUrl: {
		            dalbo: 'https://storage.googleapis.com/ember-e-dalbo/',
		            ages: 'https://storage.googleapis.com/',
	            },
	            imgBucketSrc: "",
            }
        },
        mounted() {
            this.smartTrackingView("list_outlet_workshop");

            $(".pageSearchOutlet").prop("style", "display:none");
            $(".pageSearchWorkshop").prop("style", "display:none");
            if (!this.validateAccess('outletWorkshop.outlet') && this.validateAccess('outletWorkshop.workshop')) {
                this.changeStatusTabsworkshop();
            }
            if (this.validateAccess('outletWorkshop.outlet')) {
                this.getOutlet()
            }
            // this.getWorkshop()
            // this.getOutletnonaktiftest();
            this.cekDataOnboarding()
            $('#outletnonaktif').hide();
            $('#workshopnonaktif').hide();

	        if (process.env.NODE_ENV !== "production") {
		        this.imgBucketSrc = this.bucketUrl.ages
	        } else {
		        this.imgBucketSrc = this.bucketUrl.dalbo
	        }

            this.scroll()
        },
        methods: {
            cekDataOnboarding() {
                if (localStorage.getItem("step_walkthrough") !== null && localStorage.getItem("step_walkthrough") !== "" && localStorage.getItem("step_walkthrough") == '0') {
                    this.onboardingCreateOutlet()
                    $(".btn-add-outlet").addClass("animated pulse infinite")
                }
            },
            onboardingCreateOutlet() {
                const tour = new Shepherd.Tour({
                    defaultStepOptions: {
                        scrollTo: {
                            behavior: 'smooth',
                            block: 'center'
                        },
                        // beforeShowPromise: function () {
                        //     return new Promise(function (resolve) {
                        //         setTimeout(function () {
                        //             resolve();
                        //         }, 700)
                        //     });
                        // }
                    },
                    useModalOverlay: true,
                });

                tour.addSteps([
                    {
                        classes: '',
                        title: 'Tambah data usaha',
                        text: '<p>Mari buat data <b>tempat usaha & layanan</b> yang akan Anda sediakan untuk pelanggan.</p>',
                        attachTo: {
                            element: '.btn-add-outlet',
                            on: 'top'
                        },
                        advanceOn: {
                            selector: '.btn-add-outlet',
                            event: 'click'
                        },
                        buttons: [{
                            classes: "shp-btn-left show-modal-lewati",
                            secondary: true,
                            text: 'Lewati',
                        }],
                    }
                ]);
                tour.start()
                setTimeout(() => {
                    $(".show-modal-lewati").click(function () {
                        tour.cancel()
                        $("#modal-lewati-panduan").modal({backdrop: 'static', keyboard: false})
                    })

                }, 1500)
            },
            async skipOnboarding(params) {
                $("#modal-lewati-panduan").modal("hide")
                $(".btn-add-outlet").removeClass("animated pulse infinite")
                try {
                    const datawalkthrough = new FormData
                    datawalkthrough.append('walkthrough', params)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/owner/update_status_walkthrough', datawalkthrough, this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            localStorage.setItem("step_walkthrough", params)
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },
            scroll() {
                window.onscroll = () => {
                    // list outlet
                    if ($('#loadingSpinnerOutlet').is(":hidden")) {
                        if ($("#outlet").is(":visible")) {
                            if (this.outletPagination.pageNumber <= Math.ceil(this.outletPagination.length / this.outletPagination.limit)) {
                                if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
                                    this.outletPagination.offset = (this.outletPagination.pageNumber * this.outletPagination.limit);
                                    this.getOutlet();
                                    $('#loadingSpinnerOutlet').show()
                                }
                            }
                        }
                    }

                    // list workshop
                    if ($('#loadingSpinnerWorkshop').is(":hidden")) {
                        if ($("#workshop").is(":visible")) {
                            if (this.workshopPagination.pageNumber <= Math.ceil(this.workshopPagination.length / this.workshopPagination.limit)) {
                                if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
                                    this.workshopPagination.offset = (this.workshopPagination.pageNumber * this.workshopPagination.limit);
                                    this.getWorkshop();
                                    $('#loadingSpinnerWorkshop').show()
                                }
                            }
                        }
                    }

                    // list outlet nonaktif
                    if ($('#loadingSpinnerOutletNonaktif').is(":hidden")) {
                        if ($("#outletnonaktif").is(":visible")) {
                            if (this.outletNonaktifPagination.pageNumber <= Math.ceil(this.outletNonaktifPagination.length / this.outletNonaktifPagination.limit)) {
                                if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
                                    this.outletNonaktifPagination.offset = (this.outletNonaktifPagination.pageNumber * this.outletNonaktifPagination.limit);
                                    this.getOutletnonaktif();
                                    $('#loadingSpinnerOutletNonaktif').show()
                                }
                            }
                        }
                    }

                    // list workshop nonaktif
                    if ($('#loadingSpinnerWorkshopNonaktif').is(":hidden")) {
                        if ($("#workshopnonaktif").is(":visible")) {
                            if (this.workshopNonaktifPagination.pageNumber <= Math.ceil(this.workshopNonaktifPagination.length / this.workshopNonaktifPagination.limit)) {
                                if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
                                    this.workshopNonaktifPagination.offset = (this.workshopNonaktifPagination.pageNumber * this.workshopNonaktifPagination.limit);
                                    this.getWorkshopnonaktiftest();
                                    $('#loadingSpinnerWorkshopNonaktif').show()
                                }
                            }
                        }
                    }
                };
                $("#list-search-outlet-scrolled").scroll(() => {
                    if ($('#loadingSpinnerOutletSearch').is(":hidden")) {
                        if (this.outletSearchPagination.pageNumber <= Math.ceil(this.outletSearchPagination.length / this.outletSearchPagination.limit)) {
                            if (Math.floor($("#list-search-outlet-scrolled").scrollTop()) > 0 && Math.floor($("#list-search-outlet-scrolled").scrollTop()) >= Math.floor($("#list-search-outlet").height()) - $(document).height() - 100) {
                                this.outletSearchPagination.offset = (this.outletSearchPagination.pageNumber * this.outletSearchPagination.limit);
                                this.searchOutletFunc();
                                $('#loadingSpinnerOutletSearch').show()
                            }
                        }
                    }
                })

                $("#list-search-workshop-scrolled").scroll(() => {
                    if ($('#loadingSpinnerWorkshopSearch').is(":hidden")) {
                        if (this.workshopSearchPagination.pageNumber <= Math.ceil(this.workshopSearchPagination.length / this.workshopSearchPagination.limit)) {
                            if (Math.floor($("#list-search-workshop-scrolled").scrollTop()) > 0 && Math.floor($("#list-search-workshop-scrolled").scrollTop()) >= Math.floor($("#list-search-workshop").height()) - $(document).height()) {
                                this.workshopSearchPagination.offset = (this.workshopSearchPagination.pageNumber * this.workshopSearchPagination.limit);
                                this.searchWorkshopFunc();
                                $('#loadingSpinnerWorkshopSearch').show()
                            }
                        }
                    }
                })
            },
            dashboard() {
                this.$router.push('/dashboard')
            },

            karyawan() {
                this.$router.push('/karyawan')
            },

            penggajian() {
                this.$router.push('/addpenggajian')
            },

            menu() {
                this.$router.push('/detailakunowner')
            },

            toggleMenu() {
                $("#nav-bottom").toggleClass("is-open");
            },

            add() {
                this.$emit('dataoutlet')
                this.smartTrackingClick("add_outlet_step1");

            },

            addWorkshop() {
                this.$emit('showdataworkshop')
            },

            detail(idoutlet) {
                this.$emit('gotodetailoutlet', idoutlet)
            },

            detailnonaktif(idoutlet) {
                this.$emit('gotodetailoutletnonaktif', idoutlet)
            },

            detailworkshop(idworkshop) {
                this.$emit('showdetailworkshop', idworkshop)
            },

            detailworkshopnonaktif(idworkshop) {
                this.$emit('gotodetailworkshopnonaktif', idworkshop)
            },

            // func search
            changeStatusTabsoutlet() {
                this.smartTrackingClick("list_outlet");
                $(window).scrollTop(0)
                this.statusTabs = "outlet";
                $('#nav-home-tab').click();
                if (this.statusoutletfilter === 0) {
                    this.outletPagination = {
                        limit: 20,
                        offset: 0,
                        length: 0,
                        pageNumber: 0,
                        sortBy: "nama",
                        orderBy: "ASC",
                    }
                    this.getOutlet()
                } else {
                    this.outletNonaktifPagination = {
                        limit: 20,
                        offset: 0,
                        length: 0,
                        pageNumber: 0,
                        sortBy: "nama",
                        orderBy: "ASC",
                    }
                    this.getOutletnonaktif()
                }
            },

            changeStatusTabsworkshop() {
                if (!this.validateAccess('outletWorkshop.workshop')) return
                $(window).scrollTop(0)
                this.statusTabs = "workshop";
                $('#nav-profile-tab').click();
                if (this.statusworkshopfilter === 0) {
                    this.workshopPagination = {
                        limit: 20,
                        offset: 0,
                        length: 0,
                        pageNumber: 0,
                        sortBy: "nama",
                        orderBy: "ASC",
                    }
                    this.getWorkshop()
                } else {
                    this.workshopNonaktifPagination = {
                        limit: 20,
                        offset: 0,
                        length: 0,
                        pageNumber: 0,
                        sortBy: "nama",
                        orderBy: "ASC",
                    }
                    this.getWorkshopnonaktiftest()
                }

                this.smartTrackingClick("list_workshop");

            },

            inputsearch(event) {
                var name = event.target.value;
                var input = name.replace(/[^0-9A-Za-z_.,' -]+/, '');
                this.searchKey = input;
                this.searchData()
            },

            showSearch() {
                $(".showPageSearch").addClass("animated slideInDown")
                $(".spinner").prop("style", "display:none");
                $("#textSearch").text("Minimal 2 karakter")
                $("#textSearchWorkshop").text("Minimal 2 karakter")
                $(".pageDefault").hide();
                if (this.statusTabs === 'outlet') {
                    $(".pageSearchOutlet").show();
                } else {
                    $(".pageSearchWorkshop").show();
                }
                $("#input_search_outlet").focus();
            },

            closeSearch() {
                $(".pageSearchWorkshop").hide();
                $(".pageSearchOutlet").hide();
                $(".pageDefault").show();
                $("#textSearch").text("");
                $("#textSearchWorkshop").text("");
                this.outletSearch = "";
                this.workshopSearch = "";
                this.searchKey = "";

                this.outletSearchPagination = {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama",
                    orderBy: "ASC",
                    key: "",
                }

                this.workshopSearchPagination = {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "nama",
                    orderBy: "ASC",
                    key: "",
                }
            },

            searchData() {
                $("#textSearch").text("Minimal 2 karakter")
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.outletSearch = "";
                    $(".spinner").prop("style", "display:inline-block");
                    if (this.statusTabs == "outlet") {
                        this.searchOutletFunc();
                    } else {
                        this.searchWorkshopFunc();
                    }
                }, 500);
            },

            async searchOutletFunc() {
                var key = this.searchKey;
                if (this.outletSearchPagination.offset === 0 || this.outletSearchPagination.key !== key) {
                    this.outletSearch = []
                    $("#textSearch").text("Sedang mencari...")
                    this.outletSearchPagination = {
                        limit: 20,
                        offset: 0,
                        length: 0,
                        pageNumber: 0,
                        sortBy: "nama",
                        orderBy: "ASC",
                        key: key,
                    }
                }
                if (key.length >= 2) {
                    try {
                        var idowner = localStorage.getItem('idowner');
                        const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_outlet_sorting_meta_v2?idowner=' + idowner + '&key=' + key + '&limit=' + this.outletSearchPagination.limit + '&offset=' + this.outletSearchPagination.offset, this.requestHeaders)
                        if (response.status === 200) {
                            if (response.data.status === true) {
                                for (var i = 0; i < response.data.data.length; i++) {
                                    this.outletSearch.push(response.data.data[i]);
                                }
                                this.outletSearchPagination.length += response.data.data.length
                                if (response.data.data.length > 0) {
                                    $("#textSearch").text("Ditemukan " + response.data.lenght_data + " Outlet dengan kata '" + key + "'", this.requestHeaders);
                                } else {
                                    if (this.outletSearchPagination.offset === 0) {
                                        $("#textSearch").text("Tidak menemukan '" + key + "'");
                                    }
                                }
	
	                            this.outletSearchPagination.pageNumber++
                                $(".spinner").prop("style", "display:none");
                            }
                        }
                        $('#loadingSpinnerOutletSearch').hide()
                    } catch (e) {
                        this.$catch_error_response(e)
                        $('#loadingSpinnerOutletSearch').hide()
                        $(".spinner").prop("style", "display:none");
                    }
                } else {
                    $('#loadingSpinnerOutletSearch').hide()
                    this.outletSearch = [];
                    $(".spinner").prop("style", "display:none");
                    $("#textSearch").text("Minimal 2 karakter")
                }
            },

            async searchWorkshopFunc() {
                var key = this.searchKey;
                if (this.workshopSearchPagination.offset === 0 || this.workshopSearchPagination.key !== key) {
                    this.workshopSearch = []
                    $("#textSearchWorkshop").text("Sedang mencari...")
                    this.workshopSearchPagination = {
                        limit: 20,
                        offset: 0,
                        length: 0,
                        pageNumber: 0,
                        sortBy: "nama",
                        orderBy: "ASC",
                        key: key,
                    }
                }
                if (key.length >= 2) {
                    try {
                        var idowner = localStorage.getItem('idowner');
                        const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_workshop_sorting_meta?idowner=' + idowner + '&key=' + key + '&limit=' + this.workshopSearchPagination.limit + '&offset=' + this.workshopSearchPagination.offset, this.requestHeaders)
                        if (response.status === 200) {
                            if (response.data.status === true) {
                                for (var i = 0; i < response.data.data.length; i++) {
                                    this.workshopSearch.push(response.data.data[i])
                                }
                                this.workshopSearchPagination.length += response.data.data.length
                                if (response.data.data.length > 0) {
                                    $("#textSearchWorkshop").text("Ditemukan " + response.data.lenght_data + " Workshop dengan kata '" + key + "'", this.requestHeaders);
                                } else {
                                    if (this.workshopSearchPagination.offset === 0) {
                                        $("#textSearchWorkshop").text("Tidak menemukan '" + key + "'");
                                    }
                                }
	
	                            this.workshopSearchPagination.pageNumber++
                                $(".spinner").prop("style", "display:none");
                            }
                        }
                        $('#loadingSpinnerWorkshopSearch').hide()
                    } catch (e) {
                        this.$catch_error_response(e)
                        $('#loadingSpinnerWorkshopSearch').hide()
                        $(".spinner").prop("style", "display:none");
                    }
                } else {
                    $('#loadingSpinnerWorkshopSearch').hide()
                    this.outletSearch = "";
                    $(".spinner").prop("style", "display:none");
                    $("#textSearch").text("Minimal 2 karakter")
                }
            },

            //akhir func search
            async getOutlet() {
                this.statusTabs = "outlet"
                this.cekDataOnboarding()
                if (this.outletPagination.offset === 0) {
                    $('#loadingPage').show();
                    $('#loadingPage').addClass('overlayLoading');
                    var sort_get;
                    var order_get;
                    this.outlet = [];
                }
                try {
                    sort_get = this.outletPagination.sortBy;
                    order_get = this.outletPagination.orderBy;
                    var idowner = localStorage.getItem('idowner');
                    var limit = this.outletPagination.limit;
                    var offset = this.outletPagination.offset;
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_outlet_sorting_meta_v2?idowner=' + idowner + '&sort_by=' + sort_get + '&order_by=' + order_get + '&limit=' + limit + '&offset=' + offset, this.requestHeaders);
                    if (res.status === 200) {
                        if (res.data.status === true) {
                            $('#outlet').show();
                            $('#outletnonaktif').hide();
                            var data = res.data.data;

                            this.outletPagination.length += data.length

                            for (var i = 0; i < data.length; i++) {
                                this.outlet.push({
                                    idoutlet: data[i].outlet.idoutlet,
                                    nama: data[i].outlet.nama,
                                    alamat: data[i].outlet.alamat,
                                    kota: data[i].outlet.kota,
                                    logo_url: data[i].outlet.logo_url,
                                    active: data[i].outlet.sec_active,
                                    workshop: data[i].outlet.workshop,
	                                sisa_trial: data[i].data_active.remaining_trial_days,
	                                expired: data[i].data_active.expired,
                                })
                            }
                            this.outlet_lenght_data = res.data.lenght_data
                            if (this.outlet.length === 0 && this.outletPagination.offset === 0) {
                                this.getOutletnonaktiftest();
                                $('#loadingSpinnerOutlet').hide()
                            } else {
                                $('#outletnonaktif').hide();
                                this.outletPagination.pageNumber++
                                $('#loadingSpinnerOutlet').hide()
                            }
                        }
                    }
                    if (this.outletPagination.offset === 0) {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                }
            },
            aktifnonaktifoutlet() {
                if (this.statusoutletfilter !== 0) {
                    this.getOutlet();
                    this.statusoutletfilter = 0;
                } else {
                    this.statusoutletfilter = 1;
                    this.getOutletnonaktif();
                }

            },

            async getOutletnonaktif() {
                if (this.outletNonaktifPagination.offset === 0) {
                    $('#loadingPage').show()
                    $('#loadingPage').addClass('overlayLoading');
                    var sort_get;
                    var order_get;
                    this.outletnonaktif = [];
                }
                try {
                    sort_get = this.outletNonaktifPagination.sortBy;
                    order_get = this.outletNonaktifPagination.orderBy;
                    var idowner = localStorage.getItem('idowner');
                    var limit = this.outletNonaktifPagination.limit;
                    var offset = this.outletNonaktifPagination.offset;
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_sorting_outlet_nonaktif_v2?idowner=' + idowner + '&sort_by=' + sort_get + '&order_by=' + order_get + '&limit=' + limit + '&offset=' + offset, this.requestHeaders);
                    if (res.status === 200) {
                        if (res.data.status === true) {
                            $('#outlet').hide()
                            $('#outletnonaktif').show()
                            var data = res.data.data;
                            this.outletNonaktifPagination.length += data.length;
                            for (var i = 0; i < data.length; i++) {
                                this.outletnonaktif.push({
                                    idoutlet: data[i].outlet.idoutlet,
                                    nama: data[i].outlet.nama,
                                    alamat: data[i].outlet.alamat,
                                    kota: data[i].outlet.kota,
                                    logo_url: data[i].outlet.logo_url,
	                                active: data[i].outlet.sec_active,
	                                sisa_trial: data[i].data_active.remaining_trial_days,
	                                expired: data[i].data_active.expired,
                                })
                            }
                            this.outlet_nonaktif_lenght_data = res.data.lenght_data
                            this.outletNonaktifPagination.pageNumber++
                            $('#loadingSpinnerOutletNonaktif').hide()
                        }
                    }
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                    $('#loadingSpinnerOutletNonaktif').hide()
                }
            },

            async getOutletnonaktiftest() {
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading');
                var sort_get;
                var order_get;
                try {
                    sort_get = "created_at";
                    order_get = "DESC";
                    var idowner = localStorage.getItem('idowner');
                    var limit = 20;
                    var offset = 0;
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_sorting_outlet_nonaktif?idowner=' + idowner + '&sort_by=' + sort_get + '&order_by=' + order_get + '&limit=' + limit + '&offset=' + offset, this.requestHeaders);
                    if (res.status === 200) {
                        if (res.data.status === true) {
                            this.outletnontest = [];
                            this.outlet = []
                            var data = res.data.data;
                            for (var i = 0; i < data.length; i++) {
                                this.outletnontest.push({
                                    idoutlet: data[i].idoutlet,
                                    nama: data[i].nama,
                                    alamat: data[i].alamat,
                                    kota: data[i].kota,
                                    logo_url: data[i].logo_url,
                                })
                            }

                        }
                    }
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                }
            },

            aktifnonaktifworkshop() {
                if (this.statusworkshopfilter !== 0) {
                    this.getWorkshop();
                    this.statusworkshopfilter = 0;
                } else {
                    this.statusworkshopfilter = 1;
                    this.getWorkshopnonaktiftest();
                }

            },

            async getWorkshop() {
                this.statusTabs = 'workshop'
                if (this.workshopPagination.offset === 0) {
                    $('#loadingPage').show()
                    $('#loadingPage').addClass('overlayLoading');
                    var sort_get;
                    var order_get;
                    this.workshop = [];
                }
                try {
                    sort_get = this.workshopPagination.sortBy;
                    order_get = this.workshopPagination.orderBy;
                    var idowner = localStorage.getItem('idowner');
                    var limit = this.workshopPagination.limit;
                    var offset = this.workshopPagination.offset;
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_workshop_sorting_meta?idowner=' + idowner + '&sort_by=' + sort_get + '&order_by=' + order_get + '&limit=' + limit + '&offset=' + offset, this.requestHeaders)
                    // this.workshop=res.data.data;
                    if (res.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                        $('#workshop').show();
                        $('#workshopnonaktif').hide();
                        this.leght_data_workshop = res.data.lenght_data;
                        var data = res.data.data;

                        this.workshopPagination.length += data.length

                        for (var i = 0; i < data.length; i++) {
                            var statusworkshopLogOutlet = "false";
                            var namaOutlet = "";
                            if (data[i].outlet !== null) {
                                namaOutlet = data[i].outlet.nama;
                                statusworkshopLogOutlet = "true";
                            } else {
                                // namaOutlet = data[i].outlet.nama;
                                statusworkshopLogOutlet = "false";
                            }
                            this.workshop.push({
                                idworkshop: data[i].idworkshop,
                                nama: data[i].nama,
                                alamat: data[i].alamat,
                                kota: data[i].kota,
                                loginoutletworkshop: statusworkshopLogOutlet,
                                outlet: data[i].outlet
                            })
                        }
                        if (this.workshop.length === 0 && this.workshopPagination.offset === 0) {
                            // this.getWorkshopnonaktiftest();

                            $('#loadingSpinnerWorkshop').hide()
                        } else {
                            $('#workhsopnonaktif').hide();

                            this.workshopPagination.pageNumber++
                            $('#loadingSpinnerWorkshop').hide()
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingSpinnerWorkshop').hide()
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                }
                $('#loadingPage').removeClass('overlayLoading');
                $('#loadingPage').hide()
            },

            async getWorkshopnonaktiftest() {
                if (this.workshopNonaktifPagination.offset === 0) {
                    $('#loadingPage').show()
                    $('#loadingPage').addClass('overlayLoading');
                    var sort_get;
                    var order_get;
                    this.workshopnontest = [];
                }
                try {
                    sort_get = this.workshopNonaktifPagination.sortBy;
                    order_get = this.workshopNonaktifPagination.orderBy;
                    var idowner = localStorage.getItem('idowner');
                    var limit = 20;
                    var offset = 0;
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_workshop_nonactive_sorting_meta?key=' + '&sort_by=' + sort_get + '&order_by=' + order_get + '&limit=' + limit + '&offset=' + offset, this.requestHeaders);
                    if (res.status === 200) {
                        if (res.data.status === true) {
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide();
                            $('#workshop').hide();
                            $('#workshopnonaktif').show();
                            // this.leght_data_workshop=res.data.lenght_data;
                            var data = res.data.data;
                            this.workshopNonaktifPagination.length += data.length
                            for (var i = 0; i < data.length; i++) {
                                var statusworkshopLogOutlet = "false";
                                var namaOutlet = "";
                                if (data[i].outlet !== null) {
                                    namaOutlet = data[i].outlet.nama;
                                    statusworkshopLogOutlet = "true";
                                } else {
                                    // namaOutlet = data[i].outlet.nama;
                                    statusworkshopLogOutlet = "false";
                                }
                                this.workshopnontest.push({
                                    idworkshop: data[i].idworkshop,
                                    nama: data[i].nama,
                                    alamat: data[i].alamat,
                                    kota: data[i].kota,
                                    loginoutletworkshop: statusworkshopLogOutlet,

                                })
                            }
                            this.workshop_nonaktif_lenght_data = res.data.lenght_data
                            this.workshopNonaktifPagination.pageNumber++
                            $('#loadingSpinnerWorkshopNonaktif').hide()


                        }
                    }
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingSpinnerWorkshopNonaktif').hide()
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                }
            },

            async selectSortingWorkshop(key) {


                $("#cardWorkshop").hide();
                $("#spinnerWorkshop").prop("style", "display:inline-block");
                switch (key) {
                    case "asc":
                        $('#dropdownMenuButton2').text("Urut Dari A - Z ")
                        this.getWorkshopSortingMaster(1)
                        break;
                    case "desc":
                        $('#dropdownMenuButton2').text("Urut Dari Z - A ")
                        this.getWorkshopSortingMaster(2)
                        break;
                    case "terbaru":
                        $('#dropdownMenuButton2').text("Urut Dari Terbaru ")
                        this.getWorkshopSortingMaster(3)
                        break;
                    case "terlama":
                        $('#dropdownMenuButton2').text("Urut Dari Terlama ")
                        this.getWorkshopSortingMaster(4)
                        break;
                    default:
                        $('#dropdownMenuButton2').text("Urutkan ")
                }
            },
            async getWorkshopSortingMaster(data) {
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading');
                var sort_by
                var order_by
                try {
                    if (data === 1) {
                        sort_by = "nama";
                        order_by = "ASC";
                    } else if (data === 2) {
                        sort_by = "nama";
                        order_by = "DESC";
                    } else if (data === 3) {
                        sort_by = "created_at";
                        order_by = "DESC";
                    } else if (data === 4) {
                        sort_by = "created_at";
                        order_by = "ASC";
                    } else {
                        return
                    }

                    //var key = jika ada search nanti dipake
                    var idowner = localStorage.getItem('idowner');
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_workshop_sorting_meta?idowner=' + idowner + '&order_by=' + order_by + '&sort_by=' + sort_by + '&key=', this.requestHeaders)
                    if (res.status === 200) {
                        if (res.data.status === true) {
                            this.workshop = res.data.data
                            $("#spinnerWorkshop").prop("style", "display:none");
                            $("#cardWorkshop").show();
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                }
            },
            async selectSorting(key, type) {
                this.outletPagination.limit = 20;
                this.outletPagination.offset = 0;
                this.outletPagination.length = 0;
                this.outletPagination.pageNumber = 0;

                $("#cardWorkshop").hide();
                $("#spinnerWorkshop").prop("style", "display:inline-block");
                switch (key) {
                    case "asc":
                        $('#dropdownMenuButton1').text("Urut Dari A - Z ")
                        this.getSorting(1, type)
                        break;
                    case "desc":
                        $('#dropdownMenuButton1').text("Urut Dari Z - A ")
                        this.getSorting(2, type)
                        break;
                    case "terbaru":
                        $('#dropdownMenuButton1').text("Urut Dari Terbaru ")
                        this.getSorting(3, type)
                        break;
                    case "terlama":
                        $('#dropdownMenuButton1').text("Urut Dari Terlama ")
                        this.getSorting(4, type)
                        break;
                    default:
                        $('#dropdownMenuButton1').text("Urutkan ")
                }
            },
            async getSorting(data, type) {
                var sortBy;
                var orderBy;
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading');
                if (data === 1) {
                    sortBy = "nama";
                    orderBy = "ASC";
                } else if (data === 2) {
                    sortBy = "nama";
                    orderBy = "DESC";
                } else if (data === 3) {
                    sortBy = "created_at";
                    orderBy = "DESC";
                } else if (data === 4) {
                    sortBy = "created_at";
                    orderBy = "ASC";
                } else {
                    return
                }

                if (type === "outlet") {
                    this.outletPagination.offset = 0
                    this.outletPagination.sortBy = sortBy
                    this.outletPagination.orderBy = orderBy
                    this.getOutlet()
                } else if (type === "workshop") {
                    this.workshopPagination.offset = 0
                    this.workshopPagination.sortBy = sortBy
                    this.workshopPagination.orderBy = orderBy
                    this.getWorkshop()
                } else if (type === "outletNonaktif") {
                    this.outletNonaktifPagination.offset = 0
                    this.outletNonaktifPagination.sortBy = sortBy
                    this.outletNonaktifPagination.orderBy = orderBy
                    this.getOutletnonaktif()
                } else if (type === "workshopNonaktif") {
                    this.workshopNonaktifPagination.offset = 0
                    this.workshopNonaktifPagination.sortBy = sortBy
                    this.workshopNonaktifPagination.orderBy = orderBy
                    this.getWorkshopnonaktiftest()
                }
            },
            async filter(payload) {
                if (payload.type === "outlet") {
                    this.statusoutletfilter = 0
                    this.outletPagination = payload.data
                    await this.getOutlet()
                } else if (payload.type === "workshop") {
                    this.statusworkshopfilter = 0
                    this.workshopPagination = payload.data
                    await this.getWorkshop()
                } else if (payload.type === "outletNonaktif") {
                    this.statusoutletfilter = 1
                    this.outletNonaktifPagination = payload.data
                    await this.getOutletnonaktif()
                } else if (payload.type === "workshopNonaktif") {
                    this.statusworkshopfilter = 1
                    this.workshopNonaktifPagination = payload.data
                    await this.getWorkshopnonaktiftest()
                }
                $("#dropdownMenuButton-" + payload.type).html(payload.textSorting)
            },
        },
    }

</script>

<style scoped>
    .image {
        margin-top: 185px;
        color: #333333;;
    }

    .carddd {
        margin-top: 83px;
        margin-bottom: 100px;
    }

    .textTotal {
        font-size: 16px;
        margin-left: 10px;
        color: #6F7287;
        font-weight: 600;
    }

    .textTotalSearch {
        font-size: 16px;
        margin-left: 10px;
        color: #6F7287;
        font-weight: 600;
        margin-top: 20px;
    }

    .imageSearch {
        float: right;
        height: 20px;
        width: 20px;
        margin-top: 0px;

    }

    .dropdown-menu.show {
        /*background-color: rgba(255, 255, 255, 0.75);*/
        border: none;
        box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.22);
    }

    .spinner-border-sm {
        width: 3rem;
        height: 3rem;
        border-width: .3em;
        text-align: center;
        margin-top: 80%;
        margin-left: 45%;
        color: #206cff;
    }

    .spinner-border {
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        border: .25em solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        -webkit-animation: spinner-border .75s linear infinite;
        animation: spinner-border .75s linear infinite;
    }

    .box {
        width: 50px;
        height: 50px;
    }

    .cardSearch {
        margin-top: 70px;
    }

    /*.imgFit {*/
    /*    width: 100%;*/
    /*    height: 100%;*/
    /*    object-fit: cover;*/
    /*}*/

    .backgroundSearch {
        position: fixed;
        background-color: #F2F5F7;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding-left: 20px;
        padding-right: 20px;
	    margin-top: 50px;
    }

    .image {
        margin-top: 185px;
        color: #333333;;
    }

    .inputSearch {
        padding-left: 10px;
        padding-right: 10px;
        width: 150%;
        border: none;
    }

    .inputSearch:focus {
        outline: none;
    }

    #loading-bar-spinner.spinner {
        left: 50%;
        margin-left: -20px;
        top: 50%;
        margin-top: -20px;
        position: absolute;
        z-index: 19 !important;
        animation: loading-bar-spinner 400ms linear infinite;
    }

    #loading-bar-spinner.spinner .spinner-icon {
        width: 40px;
        height: 40px;
        border: solid 4px transparent;
        border-top-color: #a6a9a9 !important;
        border-left-color: #a6a9a9 !important;
        border-radius: 50%;
    }

    #loading-bar-spinner2.spinner {
        left: 50%;
        margin-left: -20px;
        top: 50%;
        margin-top: -20px;
        position: absolute;
        z-index: 19 !important;
        animation: loading-bar-spinner 400ms linear infinite;
    }

    #loading-bar-spinner2.spinner .spinner-icon {
        width: 40px;
        height: 40px;
        border: solid 4px transparent;
        border-top-color: #a6a9a9 !important;
        border-left-color: #a6a9a9 !important;
        border-radius: 50%;
    }

    @keyframes loading-bar-spinner {
        0% {
            transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .imgFit {
        width: 48px;
        height: 48px;
        object-fit: cover;
        border-radius: 3px;
        margin-top: 2px;
    }

    .nomore {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .pointer-with-nav {
        display: flex;
        width: 54px;
        height: 54px;
        border-radius: 50%;
        background: #206CFF;
        cursor: pointer;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
        align-content: center;
        align-items: center;
        justify-content: center;
        position: fixed;
        /*bottom: 70px;*/
        bottom: 20px;
        right: 20px;

    }

    /* ---- THIS PAGE ---- */

    .section-group-line .section-item:not(:first-child) {
        border-top: 1px solid #EDEDED;
    }

</style>